import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import makeFullName from 'common/util/makeFullName';
import {
  isApplicationCompleted,
  isApplicationPaid,
  isApplicationSubmissionPaid,
} from 'common/householdApplication/applicationHelpers';

import SrHouseholdApplicationStatusButton from 'client/components/SrHouseholdApplicationStatusButton';

const SrRenterApplicationStatusRoommatesListRow = ({
  application,
  applicationSubmission,
  listing,
  isGuarantor,
  dispatch,
  history,
  currentUser,
  disabled,
}) => {
  const isPaid = isGuarantor
    ? applicationSubmission && isApplicationSubmissionPaid(applicationSubmission)
    : isApplicationPaid({ householdApplication: application });

  return (
    <div className='SrRenterApplicationStatusRoommatesListRow'>
      <div className='roommateImageContainer'>
        <div className='roommateSnippet'>
          {
            application.firstName ? application.firstName.substring(0, 1).toUpperCase() : ''
          }
        </div>
      </div>
      <div className='roommateInfoContainer'>
        <div className='nameAndStatusContainer'>
          <div className='textContainer'>
            <span className='name'>
              {`${makeFullName(application.firstName, application.lastName)}${isGuarantor
                ? ' (Guarantor)'
                : ''}`
              }
            </span>
            <span className={classnames('status', {
              completed: isPaid,
              incomplete: !isPaid,
            })}
            >
              {
                isPaid
                  ? 'Paid Application Fees'
                  : 'Application Fees Not Paid'
              }
            </span>
            <span className={classnames('status', {
              completed: isApplicationCompleted({ householdApplication: application }),
              incomplete: !isApplicationCompleted({ householdApplication: application }),
            })}
            >
              {
                isApplicationCompleted({ householdApplication: application })
                  ? 'Completed Application'
                  : 'Application Not Completed'
              }
            </span>
          </div>
        </div>
        {currentUser.id === application.userId && !application.isOnlineApp && !disabled && (
          <div className='rightButtonContainer'>
            <SrHouseholdApplicationStatusButton
              householdApplication={application}
              householdApplicationSubmission={applicationSubmission}
              listing={listing}
              dispatch={dispatch}
              history={history}
              isGuarantor={isGuarantor}
            />
          </div>
        )}
      </div>
    </div>
  );
};

SrRenterApplicationStatusRoommatesListRow.propTypes = {
  application: PropTypes.object.isRequired,
  applicationSubmission: PropTypes.object,
  listing: PropTypes.object,
  isGuarantor: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

SrRenterApplicationStatusRoommatesListRow.defaultProps = {
  isGuarantor: false,
};

SrRenterApplicationStatusRoommatesListRow.displayName = 'SrRenterApplicationStatusRoommatesListRow';

export default SrRenterApplicationStatusRoommatesListRow;
